import React from 'react';
import { Grid, Container } from '@material-ui/core';
import areas from '../../../Data/areas.data';
import { useStyle } from './useStyle';
import ActionButton from '../../../Components/ActionButton/ActionButton';
import SectionTitle from '../../../Components/SectionTitle';
import ImageMask from '../../../Components/ImageMask';
import AreaCard from '../AreaCard/AreaCard';
import { Link } from 'react-router-dom';

const Areas = ({ imgMode = true, showButton = true }) => {
	const classes = useStyle();
	const AllAreas = areas.map((area, i) => (
		<Grid key={i} item xs={6} sm={4} md={3}>
			<Link to={'/areas-of-law-practices' + area.path}>
				{imgMode ? (
					<ImageMask defaultText='cases' img={area.img} title={area.name} />
				) : (
					<AreaCard title={area.name} />
				)}
			</Link>
		</Grid>
	));
	return (
		<div className={classes.root}>
			<Container className={classes.container}>
				<SectionTitle className={classes.sectionTitle} title='Areas Of Law Practice' />
				<Grid container justify='center' spacing={3}>
					{AllAreas}
				</Grid>
				{showButton && <ActionButton link='/areas-of-law-practices' text='Show More' />}
			</Container>
		</div>
	);
};

export default Areas;
